import { FC, useCallback, useState } from 'react';
import { FormControl, TextField, IconButton, Tooltip } from '@mui/material';
import { MdContentCopy as ContentCopyIcon } from 'react-icons/md';

const ApiKeySecretTextField: FC<
  React.PropsWithChildren<ApiKeySecretTextFieldProps>
> = props => {
  const [copyTooltipTitle, setCopyTooltipTitle] = useState('Copy');
  const { keySecret } = props;

  const copyToClipboard = useCallback(() => {
    if (keySecret) {
      navigator.clipboard.writeText(keySecret);
    }

    setCopyTooltipTitle('Copied !');
  }, [keySecret, setCopyTooltipTitle]);

  return (
    <Tooltip
      arrow
      title='API Key Secret for your organization in OX Security'
      placement='bottom'
      enterDelay={1000}>
      <FormControl>
        <TextField
          variant='standard'
          size='small'
          value={keySecret}
          label='API Key Secret'
          InputProps={{
            readOnly: true,
            endAdornment: (
              <Tooltip arrow title={copyTooltipTitle} placement='top'>
                <span>
                  <IconButton onClick={copyToClipboard} size='small'>
                    <ContentCopyIcon color='success' fontSize='small' />
                  </IconButton>
                </span>
              </Tooltip>
            ),
          }}
        />
      </FormControl>
    </Tooltip>
  );
};

export interface ApiKeySecretTextFieldProps {
  keySecret: string;
}

export default ApiKeySecretTextField;
